import React from "react"

export default function FallbackLoading() {
  return (<>
    <img src="https://res.cloudinary.com/spiralyze/image/upload/v1681471338/spiralyze2021/gif-loading.gif" width={40} height={40} style={{margin: "auto", display: "block"}}/>
  </>)
}